
<div [formGroup]="mdl_Filter" class="filter-container">

    <input autocomplete="off" class="form-control" 

      [ngStyle]="getStylesObject()"

      [placeholder]="str_Placeholder"
    
      formControlName="strText"
    
      (focus)="onFocus()"

      (blur)="onBlur()"
      
      (input)="onFilter()" />

      <div class="position-absolute" style="top: 12px;left:15px">

        <!-- آیکون لیست -->

        <ng-container *ngIf="!bShowList || bFirstLoad;else isClose">  

             <i  class="fa fa-caret-down " aria-hidden="true"></i>

        </ng-container>

         <!-- آیکون بستن -->

         <ng-template #isClose>

             <i class="fa fa-times pointer" (click)="hide_List()"></i>

         </ng-template>


      </div>

    <ul *ngIf="bShowList" class="list-group">

        <li class="list-group-item pointer" 
        
            *ngFor="let item of lst_Filtered" 

            (click)="onClicked_Value(item)"
            
            [@fadeAnimation]>

            {{ item[strComment] }}

        </li>

    </ul>

</div>